import React from "react";
import { Container, Form, Button, Card } from "react-bootstrap";
import Logo  from "../assets/images/logo.png";
import { FORGOT_PASSWORD } from "../api/constants";
import Swal from "sweetalert2";
function ForgotPassword() {
  const [email, setEmail] = React.useState('');
  const [error, setError] = React.useState('');
  const [success, setSuccess] = React.useState('');

  const handeGetResetLink = async () => {
    if (!email) {
      setError('Email is required');
      return;
    }

    try {
      const response = await fetch(FORGOT_PASSWORD, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email }),
      });

      const data = await response.json();
      if (data.status) {
        Swal.fire({
          icon: "success",
          title: "Reset Link Sent",
          text: data.message || "A password reset link has been sent to your email.",
          confirmButtonText: "OK",
        });
        setEmail('');
        setError('');
      } else {
        const data = await response.json();
        setError(data.message || 'Failed to send reset link');
        setSuccess('');
      }
    } catch (error) {
      setError('An error occurred. Please try again later.');
      setSuccess('');
    }
  };



  return (
    <div className="login-sign-main common-padding" >
      <Container>
        <Card>
          <div className="login-sign-wrap">
            <img src={Logo} width={160} alt="" />
            <h3 className="mb-3">Forgot your password?</h3>
            <p className="mt-0">We will send instructions to your email to reset your password.</p>
          </div>

          <Form>
            <Form.Group className="from-group">
              <Form.Control type="email" placeholder="Enter email" value={email} onChange={(e) => setEmail(e.target.value)} />
            </Form.Group> 
            <Button onClick={handeGetResetLink} className="custom-bttn style-3 w-100 mt-3">
              Get Reset Link
            </Button>

             <p className="mb-0">
              <a href="/sign-in-continue">
                Back to Sign in
              </a>
            </p>
           
          </Form>
        </Card>
      </Container>
    </div>
  );
}

export default ForgotPassword;
